<template>
	<div class="grid p-fluid">
		<div class="col-12 lg:col-6 flex align-items-auto">
			<div class="card w-100pc">
				<h2>Dashboard</h2>
				<div class="css-image compass-logo flex flex-column dashboard-logo"></div>
			</div>
		</div>
		<div class="col-12 lg:col-6">
			<div class="card flex flex-column align-items-center">
				<h5>{{selectedService.serviceName}}</h5>
				<Chart type="doughnut" :data="doughnutData" :options="doughnutOptions" style="width: 50%;max-width:300px;" />
			</div>
		</div>
	</div>
	<PropertyDashboard ref="propertyDashboardComponent"
					   @updateOverdue="overdue = $event;"
					   @updateUpcoming="upcoming = $event;"
					   @updateAway="away = $event;"
					   @updateCompleted="completed = $event;"
					   @updateSelectedService ="selectedService = $event;"/>
</template>

<script lang="ts">
	import { Options, Vue } from 'vue-class-component';
	import PropertyList from '../views/PropertyList.vue'
	import { PropertyServiceData } from '@/api-client/api-client'
	import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
	import { PropertyDashboardComponent } from '@/utils/CompassConstants';

	Vue.registerHooks([
		'beforeRouteEnter',
	]);

	const red = '#DC143C';
	const green = '#00AF50';
	const orange = '#FF9800';
	const grey = '#D3D3D3';

	const colourOverdue = red;
	const colourUpcoming = orange;
	const colourAway = green;
	const colourCompleted = grey;

	@Options({
		name: 'Dashboard',
		components: {
			'PropertyList': PropertyList,
		},
	})
	export default class Dashboard extends Vue {

		overdue = 0;
		upcoming = 0;
		away = 0;
		completed = 0;

		selectedService: PropertyServiceData = new PropertyServiceData();

		// Event each time accessing this page, dashboard needs to be updated
		  beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
			next((vm: Vue) => {
				// ensure dashboard refreshed (should use hashedpayload to avoid large calls)
				(vm.$refs.propertyDashboardComponent as PropertyDashboardComponent).loadServicesAndSearch();
			})
		}

		get doughnutData() {
			return {
				labels: [this.overdue + ' Overdue', this.upcoming + ' Upcoming', this.away + ' Away', this.completed + ' Completed'],
				datasets: [
					{
						data: [this.overdue, this.upcoming, this.away, this.completed],
						backgroundColor: [
							colourOverdue,
							colourUpcoming,
							colourAway,
							colourCompleted
						],
						hoverBackgroundColor: [
							colourOverdue,
							colourUpcoming,
							colourAway,
							colourCompleted
						]
					}
				]
			};
		}

		get doughnutOptions() {
			return {
				animation: {
					duration: 0
				}
			}
		}
	}
</script>
